import styled from '@emotion/styled';
import { isMobile } from 'react-device-detect';

const cellMinWidth = '100px';
const rowHeight = '50px';
const cellWidth = '100px';

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.1);
  table-layout: auto;
  overflow-x: auto;
`;


const StyledThead = styled.thead`
  background-color: #f3f4f6;
  max-width: 10px;
`;

const StyledTh = styled.th`
  padding: 0.5rem;
  text-align: left;
  font-weight: 500;
  color: #374151;
  border-bottom: 2px solid #e5e7eb;
  font-size: 0.9rem;
  line-height: ${rowHeight};
  height: ${rowHeight};
  width: ${cellWidth};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: ${({ isSelect }) => (isSelect ? "1000px" : "1000px")};
`;


const StyledTd = styled.td`
  padding: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  color: #374151;
  font-size: 0.9rem;
  line-height: 20px;
  height: ${rowHeight};
  width: ${cellWidth};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledTr = styled.tr`
 &:nth-child(even) {
    background-color: #f8f9fa;
  }
  &:hover {
    background-color: #e9ecef;
    cursor: pointer;
  }
`;

const StyledTrExpanded = styled.tr`
  background-color: #f9f9f9;
  border: 1px solid #ddd; 
  border-radius: 4px;
  overflow: hidden;
  padding: ${({ isExpanded }) => (isExpanded ? "16px" : "0")};
  margin: 8px 0;
  box-shadow: ${({ isExpanded }) => (isExpanded ? "0px 2px 5px rgba(0, 0, 0, 0.1)" : "none")};

  max-height: ${({ isExpanded }) => (isExpanded ? "500px" : "0")};
  opacity: ${({ isExpanded }) => (isExpanded ? 1 : 0)};
  visibility: ${({ isExpanded }) => (isExpanded ? "visible" : "hidden")};
  
  transition: max-height 0.4s ease-in-out, opacity 0.4s ease-in-out, padding 0.4s ease-in-out, visibility 0.4s;

  td {
    padding: ${({ isExpanded }) => (isExpanded ? "16px" : "0")};
    transition: padding 0.4s ease-in-out;
  }
`;


const StyledPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledButton = styled.button`
  padding: 0.5rem 1rem;
  margin-right: 0.25rem;
  border-radius: 0.375rem;
  border: 1px solid #E5E7EB;
  background-color: #FFFFFF;
  color: #374151;
  cursor: pointer;
  font-size: 11px;

  &:hover {
    background-color: #F9FAFB;
  }

  &:disabled {
    background-color: #F3F4F6;
    color: #9CA3AF;
    cursor: default;
  }
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
  padding-left: 5px;
`;

const Label = styled.label`
  font-size: 0.8rem;
  margin-bottom: 5px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const SearchAndFilterContainer = styled.div`  
  justify-content: start;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: nowrap;
  position: sticky;
  top: 0;
  background-color:rgb(245, 245, 245);
  z-index: 99;
  padding: 10px 0;
  border-bottom: 2mm ridge ${({ colour }) => (colour?.sidebar && colour?.menuContent)};
  border-radius: 0.375rem;

  @media (max-width: 768px) {
    display: block;
    flex-wrap: wrap;
  }
`;

const StyledSelect = styled.select`
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #E2E8F0;
  background-color: #FFFFFF;
  height: 33px;

  &:focus {
    outline: none;
    border-color: #93C5FD;
    box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.5);
  }
`;

const StyledSearchInput = styled.input`
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid #E2E8F0;
  width: 100%;
  max-width: 350px;
  min-width: 150px;

  &:focus {
    outline: none;
    border-color: #93C5FD;
    box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.5);
  }
`;

const ExpandedRowContainer = styled.div`
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding:10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
`;

const SectionTitle = styled.h2`
  font-size: 1rem;
  margin-bottom: 8px;
  color: #333;
`;

const List = styled.ul`
  margin: 0;
  padding-left: 20px;
`;

const ListItem = styled.li`
  margin-bottom: 4px;
  font-size: 14px;
  color: #555;
`;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
  max-height: ${({ vhValue }) => (vhValue ? vhValue : "80vh")}; 
`;


export {
  TableContainer,
  StyledTable,
  StyledThead,
  StyledTh,
  StyledTd,
  StyledTr,
  StyledTrExpanded,
  StyledPagination,
  StyledButton,
  InputContainer,
  Label,
  SearchAndFilterContainer,
  StyledSelect,
  StyledSearchInput,
  ExpandedRowContainer,
  SectionTitle,
  List,
  ListItem
};
